// extracted by mini-css-extract-plugin
export default {"theme-toggle":"ThemeToggle_theme-toggle__cJkTF","theme-icon":"ThemeToggle_theme-icon__pUkn+"};